import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	CategoryName,
	Trigger,
	CategoryLink,
	IconWrapper,
	HiddenCheck,
	SubCats,
	SubCat,
	AllLink,
	Caret,
} from './categoryStyles';
import { svgMap } from 'core/utils/slugMaps';

class Category extends PureComponent {
	calculateSubCatHeight = () => {
		const childrenLength = this.getSubCats().length;
		// Magic numbers sorry not sorry
		const PADDING = 36; // 18px * 2
		const ITEM_HEIGHT = 40;
		const VIEW_ALL_HEIGHT = ITEM_HEIGHT;

		const childrenHeight = childrenLength * ITEM_HEIGHT;
		const total = PADDING + VIEW_ALL_HEIGHT  + childrenHeight;
		return `${total}px`;
	}

	getSubCats = () => {
		// Grab `items` from every subcategory column list
		const { children } = this.props;
		return children.reduce((accumulator, currentSection) => {
			return accumulator.concat(currentSection.items || []);
		}, []);
	}

	subCats = this.getSubCats()
	totalHeight = this.calculateSubCatHeight()

	render () {
		const {
			long, short, slug, href,
		} = this.props;
		const { totalHeight, subCats } = this;
		const SvgComponent = svgMap[slug];
		const id = `trigger-${slug}`;
		const placeholderStyles = { display: 'block', width: 36, height: 32 };

		return (
			<Wrapper>
				<HiddenCheck id={id} />
				<Trigger htmlFor={id}>
					<CategoryLink href={href ? href : `/category/${slug}/`}>
						<IconWrapper>
							{SvgComponent ? <SvgComponent /> : <div style={placeholderStyles} />}
						</IconWrapper>
						<CategoryName>{long}</CategoryName>
					</CategoryLink>
					{subCats.length > 0 && <Caret />}
				</Trigger>

				<SubCats totalHeight={totalHeight}>
					{subCats.map(({ shortName, slug, href }, index) => (
						<SubCat key={index} href={href ? href : `/category/${slug}/`}>
							{ shortName }
						</SubCat>
					))}
					{!href && (
						<AllLink href={`/category/${slug}/`} title={`View All of ${long}`}>View All</AllLink>
					)}
				</SubCats>
			</Wrapper>
		);
	}

	static propTypes = {
		long: PropTypes.string,
		short: PropTypes.string,
		slug: PropTypes.string,
		href: PropTypes.string,
		children: PropTypes.array,
	}

	static defaultProps = {
		children: [],
	}
}

export default Category;
